import reduxFetch from 'react-redux-fetch';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';
import apiRoutes from '../../../../app/api/routes';

const IDENTIFICATION_CODE_RESOURCE = 'identificationCodeDetail';

const IdentificationCodeService = ComposedComponent =>
  reduxFetch([
    {
      resource: IDENTIFICATION_CODE_RESOURCE,
      method: 'get',
      request: (id, t) => ({
        url: apiRoutes.identificationCodes(id),
        meta: {
          toaster: {
            onErrorMessage: createErrorMessage(t, 'getIdentificationCodeFailed'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default IdentificationCodeService;
